// extracted by mini-css-extract-plugin
module.exports = {"media":"NSEmbed_media__6Oq_J","vimeo":"NSEmbed_vimeo__FbENa"};